import { HEADERS } from '@autobid/strapi-integration/constants/HEADERS'
import {
  createError,
  defineNuxtRouteMiddleware,
  useRequestHeaders,
  useRuntimeConfig,
} from 'nuxt/app'

export default defineNuxtRouteMiddleware(async (to) => {
  const authorization = useRequestHeaders([HEADERS.PdfApiKey])
  const runtimeConfig = useRuntimeConfig()
  if (to.query.generatePdf === '1' || to.query.generatePdf === 'true') {
    const token = authorization[HEADERS.PdfApiKey]
    if (token !== runtimeConfig.PDF_APP_SECRET) {
      throw createError({
        statusCode: 401,
      })
    }
  }
})
